"use client"

import { Dialog } from "@base-ui/react/dialog"
import { TrashIcon, XMarkIcon } from "@heroicons/react/16/solid"
import { useActivityDock } from "@src/providers/ActivityDockProvider"
import clsx from "clsx"
import { AnimatePresence } from "framer-motion"
import { useEffect, useState } from "react"
import { DockCard } from "./DockCard"
import Spinner from "./Spinner"

const ActivityDockMobile = () => {
  const [open, setOpen] = useState(false)
  const { dockItems, clearDockItems, status } = useActivityDock()
  const hasDockItems = dockItems.length > 0

  useEffect(() => {
    if (!hasDockItems) {
      setOpen(false)
    }
  }, [hasDockItems])

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger
        type="button"
        className={clsx(
          "flex size-10 items-center justify-center rounded-xl bg-sky-500/20 focus-visible:outline-none xl:hidden dark:bg-sky-500/30",
          !hasDockItems && "hidden"
        )}
      >
        {status === "processing" ? (
          <Spinner size="md" className="text-sky-500 dark:text-white" />
        ) : (
          <div className="flex size-5 items-center justify-center rounded-full bg-sky-500 font-semibold text-sm/none text-white tracking-tight">
            {dockItems.length}
          </div>
        )}
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Backdrop
          className={clsx(
            "fixed inset-0 bg-gray-900/80 backdrop-blur-sm transition-opacity duration-200 ease-out",
            "data-ending-style:opacity-0 data-starting-style:opacity-0 data-ending-style:ease-in"
          )}
        />

        <Dialog.Popup className="fixed inset-0 z-10 w-screen overflow-y-auto transition-opacity duration-200 data-ending-style:opacity-0 data-starting-style:opacity-0">
          <Dialog.Title className="sr-only">Activity</Dialog.Title>
          <div
            role="presentation"
            className="flex min-h-full items-start justify-center px-4 pt-safe-offset-4 pb-safe-offset-4 text-center"
            onClick={() => setOpen(false)}
            onKeyDown={() => {}}
          >
            <div
              role="presentation"
              className="relative w-full max-w-sm transform overflow-hidden text-left transition-all"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <div className="mb-4 flex items-center justify-between">
                {hasDockItems ? (
                  <button
                    type="button"
                    className="flex h-10 items-center justify-center gap-2 rounded-xl bg-white px-3 font-semibold text-gray-700 text-sm focus-visible:outline-none"
                    onClick={() => clearDockItems()}
                  >
                    Clear
                    <TrashIcon className="size-5 shrink-0" />
                  </button>
                ) : (
                  <div />
                )}
                <button
                  type="button"
                  className="flex h-10 items-center justify-center gap-2 rounded-xl bg-white px-3 font-semibold text-gray-700 text-sm focus-visible:outline-none"
                  onClick={() => setOpen(false)}
                >
                  Close
                  <XMarkIcon className="size-5 shrink-0" />
                </button>
              </div>

              <AnimatePresence mode="popLayout" initial={false}>
                {dockItems.toReversed().map((item, index) => (
                  <DockCard key={item.id} item={item} isFirst={index === 0} />
                ))}
              </AnimatePresence>
            </div>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ActivityDockMobile
